module.exports = __webpack_public_path__ + "img/installations OneB Mapper_3 prew.76a47434.jpg";